
import { defineComponent, ref } from 'vue'
import { FormDialog, SendVeriButton } from '@/components/Common'
import { useDialogCommon, useDialogFormData } from '@/hooks';
import { ResetPasswordByMobile } from '@/api-server/modules/defaultServer';

import { initFormData } from './UserPwdEditData'
import { mobileReg } from '@/utils/regs';
import { ElMessage } from 'element-plus';


export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    mobile: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      default: () => ({ ...initFormData }),
    },
  },

  components: {
    FormDialog,
    SendVeriButton
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const formDialogRefs = ref<any>(null)
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(
      props,
      { ...initFormData },
      {
        type: "resetWithInitFormData",
        visiableRef: visibleRef,
      },
      (editFormDataRef) => {
        editFormDataRef.value.mobile = props.mobile
      }
    )

    const rules = {
      mobile: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        {
          pattern: mobileReg,
          message: "手机号不符合格式",
          trigger: "blur",
        },
      ],
      mobile_code: [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ],
      new_password: [
        { required: true, message: "请输入密码", trigger: ["change", "blur"] }
      ],
      repeat_new_password: [
        { required: true, message: '请再次输入密码', trigger: 'change' },
        {
          validator: (rule: any, value: any, callback: any) => {
            if (value === "") {
              return callback(new Error("请再次输入密码"));
            }
            if (editFormData.value.new_password !== value) {
              return callback(new Error("密码与确认密码不一致"));
            }
            return callback();
          },
        },
      ],
    }

    function sendResetMsgHandle() {
      return new Promise((resolve, reject) => {
        if(formDialogRefs.value && formDialogRefs.value.formRefs) {
          formDialogRefs.value.formRefs.validateField('mobile', (errorMessage: string) => {
            if (errorMessage) {
              reject(new Error(errorMessage));
            }
            resolve({
              action: "reset",
              phone: editFormData.value.mobile,
            });
          })
        }
      })
    }

    async function saveFormHandle() {
      await ResetPasswordByMobile.fetch({
        ...editFormData.value
      })
      ElMessage.success('更改成功')
      visibleRef.value = false
      context.emit("updateSuccess", { ...editFormData.value });
    }
  
    return {
      formDialogRefs,
      visibleRef,
      editFormData,
      rules,
      sendResetMsgHandle,
      saveFormHandle
    }
  },
})
